import {useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {DetailHeroSummaryProvider, DetailTabBar} from "../../../../components/detailLayout";
import "../../../../components/detailLayout/detailListLayout.css";
import {getDepreciation} from "../../../../api/asset/AssetDepreciationService";
import {AssetDepreciationInfo} from "./subPages/AssetDepreciationInfo";
import {CommonHistoryList} from "../../../settings/history/subPages/CommonHistoryList";
import {useDispatch, useSelector} from "react-redux";
import {skeleton} from "../../../../redux/slice/apiSlice";
function AssetDepreciationTab(){
    const { id } = useParams();
    const status = useSelector(state => state.api.status);

    const [tab, setTab] = useState([
        {clicked: true, name: "기본정보"},
        {clicked: false, name: "이력관리"},
    ]);

    const [depreciation, setDepreciation] = useState(null);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    async function getData() {

        getDepreciation(id).then((response) => {
            if(response.status === 201) {
                if (response.data.errorCode = 'AUTHORITY') {
                    alert(response.data.reason)
                    navigate(-1)
                }
            }

            if (response.status === 200) {
                setDepreciation(response.data);
            } else if (response.response.status === 401) {
                alert("로그인이 필요합니다.")
                navigate("/")
            } else if (response.response.status === 403) {
                alert("권한이 없습니다.")
                navigate("/")
            }
        }).catch(error => {
        })
        dispatch(skeleton(false));
    }

    useEffect(() => {
        if (!id) return;
        setDepreciation(null);
        getData();
    }, [id, status])

    if(depreciation) {
        return (
                <div className="common-container container-height detail-list-layout asset-detail-list-layout border-l-gray">
                    <DetailHeroSummaryProvider>
                        <DetailTabBar tabs={tab} setTabs={setTab} />

                    {tab[0].clicked && (
                        <AssetDepreciationInfo
                            key={id}
                            depreciation={depreciation}
                            setDepreciation={setDepreciation}
                        />
                    )}
                    {tab[1].clicked && <CommonHistoryList id={id} tableName={"감가상각관리"} />}
                    </DetailHeroSummaryProvider>
                </div>
        );
    }
}

export {AssetDepreciationTab}